<template>
  <v-dialog
    :value="isOpen"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title :class="type === 'accepted' ? 'success white--text' : 'error white--text'">
        <p class="pl-3 mt-2 mb-2">{{ title }}</p>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$emit('cancel')"
          :disabled="loading"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          :color="type === 'accepted' ? 'success' : 'error'"
          @click="$emit('confirm')"
          :loading="loading"
          :disabled="loading"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'ยืนยัน'
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'ตกลง'
    },
    cancelText: {
      type: String,
      default: 'ยกเลิก'
    },
    type: {
      type: String,
      default: 'accepted',
      validator: (value) => ['accepted', 'declined'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tool/ConfirmDialog.vue